import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);
// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来

import index from "../../components/index";
import indexMoreBookList from "../../components/indexMoreBookList";

import classify from "../../components/classify";

import search from "../../components/search";

import classBookList from "../../components/classBookList";

import bookInfo from "../../components/bookInfo";

import self from "../../components/self";

import changePwd from "../../components/changePwd";

import login from "../../components/login";

import audio from "../../components/audio";

import aboutUs from "../../components/aboutUs";

import appAboutUs from "../../components/appAboutUs";

import err from "../../components/err";



// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
const routes = [
    // {
    //     path: '/',
    //     name: 'loading',
    //     component: loading
    // },
    {
        path: '/index/:classTypeId/:officeId',
        name: 'index',
        component: index
    },
    {
        path: '/home',
        name: 'home',
        component: index
    },
    {
        path: '/indexMoreBookList',
        name: 'indexMoreBookList',
        component: indexMoreBookList
    },
    {
        path: '/classify',
        name: 'classify',
        component: classify,
        meta: {
            requiresAuth: true,
            keepAlive: true,//此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
        }
    },
    {
        path: '/search',
        name: 'search',
        component: search,
        meta: {
            requiresAuth: true,
            keepAlive: true,//此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
        }
    },
    {
        path: '/classBookList',
        name: 'classBookList',
        component: classBookList,
        meta: {
            requiresAuth: true,
            keepAlive: true,//此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
        }
    },
    {
        path: '/bookInfo/:id',
        name: 'bookInfo',
        component: bookInfo
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/self',
        name: 'self',
        component: self
    },
    {
        path: '/changePwd',
        name: 'changePwd',
        component: changePwd
    },
    {
        path: '/audio/:id',
        name: 'audio',
        component: audio
    },
    {
        path: '/appAboutUs',
        name: 'appAboutUs',
        component: appAboutUs
    },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        component: aboutUs
    },
    {
        path: '/err',
        name: 'err',
        component: err
    },
]

export const router = new VueRouter({
    mode: 'history',
    // base: "/test/",
    routes // (缩写) 相当于 routes: routes
})

let Base64 = require('js-base64').Base64;

import allApi from "./api";
import store from "./store";
import setTitleHack from "./setTitle";
import wxFn from "./wxSdk";


router.beforeEach((to, from, next) => {
    // console.log(to)
    // console.log(from)

    if (!from.name && from.fullPath == "/" && to.name == "index") {
        // console.log(location.href);
        store.commit('setdefaultLink', location.href);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            store.commit('setisFirstIos', true);
            let hs = location.protocol.slice(0, -1);
            let url = null;
            if (store.state.isFirstIos) {
                store.commit('setisFirstIos', false);
                if (hs == 'http') {
                    url = Base64.encode(hs + '://' + store.state.defaultLink.slice(7))
                } else if (hs == 'https') {
                    url = Base64.encode(hs + '://' + store.state.defaultLink.slice(8))
                }
                wxFn(url)
            } else {
                return false;
            }

        }

        // console.log(to)
        // return false;
        // 版本
        // alert(to.params.classTypeId)
        if (to.query.hideLogout == 1) {
            localStorage.setItem("hideLogout", to.query.hideLogout);
        } else {
            localStorage.removeItem("hideLogout")
        }
        var changed = null;
        if (localStorage.getItem("officeId") == Base64.decode(to.params.officeId)) {
            changed = false;
        } else {
            changed = true;
        }
        localStorage.setItem("classTypeId", Base64.decode(to.params.classTypeId));
        store.commit('setClassTypeId');
        // 机构Id
        localStorage.setItem("officeId", Base64.decode(to.params.officeId));
        store.commit('setOfficeId');
        var data = {
            officeId: localStorage.getItem("officeId"),
            classTypeId: localStorage.getItem("classTypeId"),
            changed: !to.query.ticket ? changed : false,
            ticket: {
                ticket: !to.query.ticket ? (localStorage.getItem("ticket") ? localStorage.getItem("ticket") : "") : to.query.ticket
            }
        }
        // 少儿版106/教图版107/公图版108/红色经典111/反腐倡廉113/圆音学院114
        var classTypeName = null;
        if (localStorage.getItem("classTypeId") == 106) {
            classTypeName = "少儿版";
        } else if (localStorage.getItem("classTypeId") == 107) {
            classTypeName = "教图版";
        } else if (localStorage.getItem("classTypeId") == 108) {
            classTypeName = "公图版";
        } else if (localStorage.getItem("classTypeId") == 111) {
            classTypeName = "红色经典";
        } else if (localStorage.getItem("classTypeId") == 113) {
            classTypeName = "反腐倡廉";
        } else if (localStorage.getItem("classTypeId") == 114) {
            classTypeName = "圆音学院";
        }
        console.log(11111111111111);
        allApi.product(data).then((resource) => {
            console.log(resource, "216");
            // console.log(JSON.parse(resource.data.data))
            // console.log(JSON.parse(JSON.parse(resource.data.data).message))
            // if( JSON.parse(resource.data.data).flag ) {
            // setTitleHack(JSON.parse(JSON.parse(resource.data.data).message).officeName + '-' + classTypeName);
            setTitleHack(JSON.parse(JSON.parse(resource.data.data).message).officeName);
            // 机构名称
            localStorage.setItem("officeName", JSON.parse(JSON.parse(resource.data.data).message).officeName);
            // 用户名
            localStorage.setItem("userName", JSON.parse(JSON.parse(resource.data.data).message).userName);
            // 昵称
            localStorage.setItem("nickName", JSON.parse(JSON.parse(resource.data.data).message).nickName);
            // 用户头像
            localStorage.setItem("headPortrait", JSON.parse(JSON.parse(resource.data.data).message).headPortrait);
            // 是否登录
            localStorage.setItem("status", JSON.parse(JSON.parse(resource.data.data).message).status);
            if (localStorage.getItem("status") == 'true') {
                localStorage.removeItem("showRowNum");
            }
            // 是否显示微信登录
            localStorage.setItem("allowWeChatAuth", JSON.parse(JSON.parse(resource.data.data).message).params.allowWeChatAuth)
            // 是否读者证账号登录
            localStorage.setItem("allowUserNameLogin", JSON.parse(JSON.parse(resource.data.data).message).params.allowUserNameLogin)
            // 用户账号到期时间
            if (JSON.parse(JSON.parse(resource.data.data).message).expireDate) {
                localStorage.setItem("expireDate", JSON.parse(JSON.parse(resource.data.data).message).expireDate);
            } else {
                localStorage.setItem("expireDate", -1);
            }
            // 用户账号类型 0是会员  1是普通
            localStorage.setItem("userType", JSON.parse(JSON.parse(resource.data.data).message).userType);
            // sessionId
            localStorage.setItem("ticket", JSON.parse(JSON.parse(resource.data.data).message).ticket);
            // 公钥
            localStorage.setItem("puk", "-----BEGIN PUBLIC KEY-----" + JSON.parse(resource.data.data).puk + "-----END PUBLIC KEY-----");
            // 验签
            // Vue.prototype.$rsa.checkSign(localStorage.getItem("puk"), JSON.parse(resource.data.data).message, JSON.parse(resource.data.data).sign)
            // 过期信息
            if (JSON.parse(resource.data.data).errorMsg) {
                localStorage.setItem("errMsg", JSON.parse(resource.data.data).errorMsg)
            } else {
                localStorage.removeItem('errMsg')
            }
            next();
            // }else{
            //     store.commit('setErrorMsg', JSON.parse(resource.data.data).message);
            //     localStorage.setItem("errMsg", JSON.parse(resource.data.data).message)
            //     next("/err");
            // }
        })

    } else {
        setTitleHack(localStorage.getItem("officeName"));
        next();
    }
})

router.afterEach((to, from) => {
    let hs = location.protocol.slice(0, -1);
    // console.log(to)
    let url = null;
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return false;
    } else {
        url = Base64.encode(hs + '://' + location.host + to.fullPath);
        wxFn(url)
    }

    // console.log(url)

})
